<template>
    <div class="wrapper wrapper--no-max-width">
        <header class="row__header">
            <h1>{{ $t('wallet.tokens') }}</h1>
        </header>
        <div class="tiles">
            <token-wallet-tile v-for="(ledger, index) in tokensWithBalance"
                :id="`wallet-token-${index}`"
                :key="index"
                :ledger="ledger"
            />
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import tokenWalletTile from '@webapp/components/token-tiles/token-wallet-tile.vue';

export default {
    name: 'wallet-tokens',
    components: {
        tokenWalletTile,
    },
    computed: {
        ...mapGetters('wallet', ['ledgersByDecentralizedByBalance']),

        // Filter out the list of ledgers to include only Tokens with a balance that is greater than 0
        tokensWithBalance() {
            return this.ledgersByDecentralizedByBalance.filter((ledger) => (Number(ledger.balance) + Number(ledger.lockedBalance)) > 0);
        },
    },
};
</script>

<style lang="scss">
.tiles {
    display: flex;
    flex-wrap: wrap;
    padding: 0 2rem;
}
</style>